import { createContext } from 'react';
import { type ToastPosition } from '~/types';

export interface Toast {
  id: string;
  title?: string;
  description: string;
  type: 'error' | 'success' | 'info' | 'warning';
  position?: ToastPosition;
  autoClose?: number | false;
}

export interface ToastContextValue {
  addToast: (toast: Omit<Toast, 'id'>) => void;
  removeToast: (id: string) => void;
  defaultPosition: ToastPosition;
}

export const ToastContext = createContext<ToastContextValue | undefined>(
  undefined,
);
